<template>
  <h2 class="hd-type-01 -left">
    <span>{{ title }}</span>
  </h2>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
